export const AgeGroups = [
  ...Array.from({ length: 11 }, (_, i) => (i + 8).toString()),
  '18+',
] as const;
